<template>
    <div class="container">
            <app-header></app-header>
            <alert></alert>
            <main role="main">
                <slot></slot>
            </main>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import { store } from '../store/store.js'
    import AppHeader from './AppHeader.vue'
    import AppFooter from './AppFooter.vue'
    import Alert from './Alert.vue'

export default {
    components: {
        AppHeader,
        AppFooter,
        Alert
    }
}


</script>

<style scoped>
  .content{
    padding-top:20px;
    padding-bottom:20px;
  }
  .container{
    text-align:left;
    color: rgba(0,0,0,.80);
  }
  /** >>> this will affect the child component **/
  main{
    box-shadow: 5px 5px 25px 0px rgba(46, 61, 73, 0.2); background-color: white;
    border-radius: .3rem;
  }
  
.btn-outline-primary:hover {
    color: #fff!important;
    background-color: #6AD5BF;
    border-color: #65CB99;
}

.btn-outline-primary {
    color: #6AD5BF!important;
    border-color: #6AD5BF;
}
</style>


// WEBPACK FOOTER //
// src/components/MainLayout.vue